import { SET_TABLE_UI } from 'store/key';
import { produce } from 'utility/general';

const initialState = {};

export const setTableUI = (data) => ({
    type: SET_TABLE_UI,
    payload: data,
});

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_TABLE_UI:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};
export default reducer;
